var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(0 -2.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M7.5,10A3.75,3.75,0,1,0,3.75,6.25,3.75,3.75,0,0,0,7.5,10ZM10,6.25a2.5,2.5,0,1,1-2.5-2.5A2.5,2.5,0,0,1,10,6.25Zm5,10a1.224,1.224,0,0,1-1.25,1.25H1.25A1.224,1.224,0,0,1,0,16.25c0-1.25,1.25-5,7.5-5S15,15,15,16.25Zm-1.25,0a3.34,3.34,0,0,0-1.04-2.08C11.9,13.35,10.361,12.5,7.5,12.5s-4.4.85-5.21,1.665a3.347,3.347,0,0,0-1.04,2.08Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M16.875,6.25a.625.625,0,0,1,.625.625V8.75h1.875a.625.625,0,0,1,0,1.25H17.5v1.875a.625.625,0,0,1-1.25,0V10H14.375a.625.625,0,0,1,0-1.25H16.25V6.875A.625.625,0,0,1,16.875,6.25Z",
    fill: "#fff",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserList);
export default __webpack_public_path__ + "static/media/user-list.d529a9551e24f4da43a50a76ccafaf02.svg";
export { ForwardRef as ReactComponent };